import { Box } from '@chakra-ui/react'
import { Form } from 'components'

export default function Select({ items = [], placeholder = 'Selecione uma opção', ...props }){

    return(
      <Form.Field {...props}>
        <Box
            as="select"
            w="100%"
            py={2}
            px={2}
            background="bg.muted"
            border="1px solid"
            borderColor="border.subtle"
            borderRadius={4}
            _dark={{
                background: '#16191d',
                borderColor: 'rgba(255,255,255,0.32)',
                color: 'rgba(255,255,255,0.92)',
            }}
            {...props}
        >
          <option disabled selected>{placeholder}</option>
          { items.map(item => <option key={item.value} value={item.value}>{item.label}</option>) }
        </Box>
      </Form.Field>
    )
}
